import axios from './userInstance'
import {getCompanyUserLinkEndpoint} from './linkUserToCompany'

const unlinkUserFromCompany = async (email: string, companyId: string) => {
    const response = await axios.delete(
        getCompanyUserLinkEndpoint(companyId),
        {data: {email}},
    )
    return response.data
}

export default unlinkUserFromCompany

